import React from 'react'
import { Box } from '@mui/material'
import { pointText, batsuText } from '../../../lib/rule'

const PlayerComp = ({ simple, rule, label }) => {
  const [pt, bt] = [pointText(simple), batsuText(simple)]

  return (
    rule.comprehensive.active &&
    <Box component="span" className="rule-element">
      <Box component="span" className="rule-title">{label || '総合ポイント'}</Box>
      <Box component="span" className="rule-content">
        {rule.comprehensive.calc === 'mul' && <>{pt}と{bt}の積</>}
        {rule.comprehensive.calc === 'sub' && <>{pt}と{bt}の差</>}
      </Box>
    </Box>
  )
}

export default PlayerComp
